import { parse, parseISO } from 'date-fns';
import type { Event } from 'library/models/events';
import normalizeTimetable from './normalizeTimetable';

const resetEditor = (event: Event) => {
  return {
    address: { ...event.address },
    cost: event.cost,
    cost_payment_method: event.cost_payment_method,
    costs: [...event.costs],
    contacts: event.contacts,
    description: event.description,
    event_block: [...event.event_block],
    event_coach: [...event.event_coach],
    event_image: event.event_image,
    event_type: event.event_type,
    external_service: event.external_service,
    language: event.language,
    mode: event.mode === 'O' ? 'O' : 'N',
    places: event.places,
    refusal: event.refusal,
    tags: event?.tags.map((tag) => tag.id),
    time_from: parseISO(event.time_from),
    time_to: parseISO(event.time_to),
    title: event.title,
    timetable: event.timetable
      ? normalizeTimetable(event.timetable)
      : [
          {
            time_from_day: new Date(),
            time_from: new Date(),
            time_to: new Date(),
          },
        ],
    youtube_url: event.presentation_video?.youtube_url ?? '',
    video_type: event.presentation_video?.video_type ?? 'B',
    video_file: event.presentation_video?.metadata?.FileName ?? '',
  };
};

export default resetEditor;
